import { type AxiosResponse } from 'axios'
import { baseApi } from 'entities/Auth/lib'
import type {
  IRequestCreateAuthClient,
  IRequestCreatePersonalAccessToken,
  IResponseAuthClient,
  IResponseCreatePersonalAccessToken,
  IResponsePersonalAccessToken,
  IResponseAuthToken,
  IResponseApiScopes,
} from './types'

class Api {
  getAuthClients(): Promise<AxiosResponse<IResponseAuthClient[]>> {
    return baseApi.get('auth/clients')
  }

  createAuthClient(data: IRequestCreateAuthClient): Promise<AxiosResponse<IResponseAuthClient>> {
    return baseApi.post('auth/clients', data)
  }

  updateAuthClient(
    id: number,
    data: IRequestCreateAuthClient
  ): Promise<AxiosResponse<IResponseAuthClient>> {
    return baseApi.put(`auth/clients/${id}`, data)
  }

  revokeAuthClient(id: number): Promise<AxiosResponse<void>> {
    return baseApi.delete(`auth/clients/${id}`)
  }

  getPersonalAccessTokens(): Promise<AxiosResponse<IResponsePersonalAccessToken[]>> {
    return baseApi.get('auth/personal-access-tokens')
  }

  createPersonalAccessToken(
    data: IRequestCreatePersonalAccessToken
  ): Promise<AxiosResponse<IResponseCreatePersonalAccessToken>> {
    return baseApi.post('auth/personal-access-tokens', data)
  }

  revokePersonalAccessToken(id: string): Promise<AxiosResponse<void>> {
    return baseApi.delete(`auth/personal-access-tokens/${id}`)
  }

  getAuthTokens(): Promise<AxiosResponse<IResponseAuthToken[]>> {
    return baseApi.get('auth/tokens')
  }

  revokeAuthToken(id: string): Promise<AxiosResponse<void>> {
    return baseApi.delete(`auth/tokens/${id}`)
  }

  getApiScopes(): Promise<AxiosResponse<IResponseApiScopes[]>> {
    return baseApi.get('auth/public-api-scopes')
  }
}

export const DeveloperAuthApi = new Api()
